import styled from '@benzinga/themetron';
import { ReactNode } from 'react';
import React from 'react';
import { TestSlider } from './slider';
interface SliderBoxProps {
  preIcon: ReactNode;
  postIcon: ReactNode;
  title: string;
  max: number;
  min: number;
  value: number;
  onChange(value: number | number[]): void;
}

export const SliderBox: React.FC<SliderBoxProps> = props => {
  return (
    <Wrapper>
      {props.preIcon && <IconWrapper>{props.preIcon}</IconWrapper>}
      <Content>
        <DataRow>
          <TitleWrapper>{props.title}</TitleWrapper>
          <ValueWrapper>{props.value}</ValueWrapper>
        </DataRow>
        <TestSliderWrapper>
          <TestSlider max={props.max} min={props.min} onChange={props.onChange} value={props.value} />
        </TestSliderWrapper>
      </Content>
      {props.postIcon && <>{props.postIcon}</>}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  border: 1px ${props => props.theme.colors.actionFocus} solid;
  border-radius: 4px;
  display: flex;
  flex-direction: row;

  color: ${props => props.theme.colors.foregroundInactive};
  display: flex;
  flex-grow: 1;
  font-family: 'Nimbus Sans D OT';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

const IconWrapper = styled.div`
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.theme.colors.actionFocus};

  position: relative;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px 12px 0px;
  position: relative;
`;

const DataRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 8px;
`;

const ValueWrapper = styled.div`
  font-size: 20px;
  color: ${props => props.theme.colors.foregroundActive};
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-grow: 1;
`;

const TestSliderWrapper = styled.div`
  left: 12px;
  right: 12px;
  width: calc(100% - 24px);
  bottom: -6px;
  position: absolute;
`;
